import alt from 'framework/alt';
import IdentityActions from 'actions/IdentityActions';
import PreferenceStore from 'stores/PreferenceStore';
import { find } from 'lodash';

class IdentityStore {
  static IDENTITY_STATE = {
    APPROVED: 'approved',
    PENDING: 'pending',
    PENDING_VERIFICATION: 'pending_verification',
    PENDING_GOVERNMENT_ID: 'pending_government_id_upload',
    PENDING_CONFIRM_IDENTITY: 'pending_confirm_identity',
    PENDING_MANUAL_APPROVAL: 'pending_manual_approval',
    PENDING_UPDATE_IRIDIUM: 'pending_update_iridium',
    PENDING_ASIN: 'pending_asin',
  };

  static MAX_CLAIMS = 3;

  constructor() {
    this.state = {
      identities: undefined,
      currentIdentity: undefined,
    };

    this.on('bootstrap', () => {
      const { currentAuthorId } = PreferenceStore.getState();
      this.setState((prevState) => {
        const modifiedIdentities = prevState.identities.map(identity => ({
          ...identity,
          isAcknowledged: identity.state === IdentityStore.IDENTITY_STATE.APPROVED,
        }));
        const currentIdentity = find(modifiedIdentities,
          identity => identity.amazonAuthorId === currentAuthorId);

        return {
          currentIdentity: currentIdentity || modifiedIdentities[0],
          identities: modifiedIdentities,
        };
      });
    });

    this.bindListeners({
      claimSucceeded: IdentityActions.claimSucceeded,
      claimFailed: IdentityActions.claimFailed,
      fetchSucceeded: IdentityActions.fetchSucceeded,
      fetchFailed: IdentityActions.fetchFailed,
      acknowledge: IdentityActions.acknowledged,
      confirmSucceeded: IdentityActions.confirmSucceeded,
      confirmFailed: IdentityActions.confirmFailed,
    });
  }

  claimSucceeded(newIdentity) {
    const modifiedIdentity = {
      ...newIdentity,
      isAcknowledged: false,
    };
    const { identities } = this.state;
    identities.unshift(modifiedIdentity);
    this.setState({
      currentIdentity: modifiedIdentity,
      identities,
      error: false,
    });
  }

  claimFailed(err) {
    this.setState({
      error: err,
    });
  }

  fetchSucceeded(identities) {
    this.setState((prevState) => {
      let currentIdentity = prevState.currentIdentity || identities[0];

      const newIdentities = identities.map((identity) => {
        if (identity.amazonAuthorId === currentIdentity.amazonAuthorId) {
          currentIdentity = identity;
        }
        return {
          ...identity,
          isAcknowledged: this.isIdentityAcknowledged(identity),
        };
      });

      return {
        currentIdentity,
        identities: newIdentities,
        error: false,
      };
    });
  }

  fetchFailed(err) {
    this.setState({
      error: err,
    });
  }

  acknowledge(amazonAuthorId) {
    const { identities, currentIdentity } = this.state;

    const newIdentities = identities.map((identity) => {
      if (identity.amazonAuthorId === amazonAuthorId) {
        return {
          ...identity,
          isAcknowledged: true,
        };
      }
      return {
        ...identity,
      };
    });

    if (currentIdentity.amazonAuthorId === amazonAuthorId) {
      currentIdentity.isAcknowledged = true;
    }

    this.setState({
      currentIdentity,
      identities: newIdentities,
    });
  }

  confirmSucceeded(confirmedIdentity) {
    this.setState({
      currentIdentity: confirmedIdentity,
      error: false,
    });
  }

  confirmFailed(err) {
    this.setState({
      error: err,
    });
  }

  isIdentityAcknowledged(newIdentity) {
    let exists = false;
    let isAcknowledged = false;

    // Check if the new identity was already in the store, and if it was acknowledged
    this.state.identities.forEach((identity) => {
      if (identity.amazonAuthorId === newIdentity.amazonAuthorId) {
        exists = true;
        ({ isAcknowledged } = identity);
      }
    });

    /* If this identity wasn't already in the store
    and is approved, it must have been claimed in
    a different session, so mark it as acknowledged */
    if (!exists && newIdentity.state.toLowerCase() === IdentityStore.IDENTITY_STATE.APPROVED) {
      isAcknowledged = true;
    }

    return isAcknowledged;
  }
}

export default alt.createStore(IdentityStore, 'IdentityStore');
